module.exports = __webpack_public_path__ + "img/passo-2.daf055b3.png";